import { getGrafanaUri, getRequestLogUri } from "../utils/grafana";
import { History } from "@mui/icons-material";
import { LinkButton } from "./linkButton";

export const GrafanaButton = ({
  expr,
  grafanaUri,
  label = "Server logs",
  ...rest
}) => {
  return (
    <LinkButton
      className="GrafanaButton"
      color="primary"
      to={grafanaUri || getGrafanaUri(expr)}
      target="_blank"
      startIcon={<History />}
      label={label}
      {...rest}
    />
  );
};

export const GrafanaRequestButton = ({ request_id, timestamp, ...rest }) => (
  <GrafanaButton
    grafanaUri={getRequestLogUri(request_id, timestamp)}
    {...rest}
  />
);
